module.exports = __webpack_public_path__ + "img/molitfelnic_targoviste-1545-big.97dbe47a.png";